// WHY: the single JS breakpoint for the mobile shell switch (REVIEW §4.1). MainLayout reads this to
// swap the desktop sidebar+outlet tree for the MobileStrip. The query MUST match the CSS phone tier
// (`max-width: 767px`) exactly — introducing a second breakpoint value anywhere is a canon violation
// (validate:breakpoints). useSyncExternalStore keeps the read tear-free across concurrent renders.
import { useSyncExternalStore } from 'react';

const QUERY = '(max-width: 767px)';
const mql = typeof window !== 'undefined' ? window.matchMedia(QUERY) : null;

function subscribe(onChange: () => void) {
  mql?.addEventListener('change', onChange);
  return () => mql?.removeEventListener('change', onChange);
}

function getSnapshot(): boolean {
  return mql?.matches ?? false;
}

// CONSTRAINT: server snapshot is always false — the shell renders desktop-first and hydrates to the
// strip on the client where matchMedia exists. (This SPA has no SSR, but the contract stays honest.)
function getServerSnapshot(): boolean {
  return false;
}

export function useIsMobile(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
